import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { postData, getData } from "../../../services/Fetchnodeservices";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const XIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const SearchIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

const WalletIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M22 12v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5z" />
    <path d="M22 12h-6a2 2 0 0 0-2 2 2 2 0 0 0 2 2h6" />
    <line x1="18" y1="9" x2="18" y2="9.01" />
  </svg>
);

const DashboardIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const OrdersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

const StarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const UsersIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const RestaurantIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M3 3h7v7H3z" />
    <path d="M14 3h7v7h-7z" />
    <path d="M14 14h7v7h-7z" />
    <path d="M3 14h7v7H3z" />
  </svg>
);

const SettingsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const ReportsIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

const ShieldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const RolesIcon = () => (
  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const PERMISSIONS_DATA = {
  "Dashboard": {
    icon: <DashboardIcon />,
    label: "Dashboard",
    permissions: [
      { id: "dashboard", label: "Dashboard Access" },
      {
        id: "stats_cards",
        label: "Stats Cards",
        children: [
          { id: "total_revenue", label: "Total Revenue" },
          { id: "total_orders", label: "Total Orders" },
          { id: "pending_orders", label: "Pending Orders" },
          { id: "completed_orders", label: "Completed Orders" },
          { id: "cancelled_orders", label: "Cancelled Orders" },
          { id: "customers", label: "Customers" },
          { id: "restaurants", label: "Restaurants" },
          { id: "delivery_riders", label: "Delivery Riders" }
        ]
      },
      { id: "revenue_live_orders", label: "Revenue & Live Orders" },
      { id: "analytics", label: "Analytics Section" },
      { id: "payment_distribution", label: "Payment Method Distribution" }
    ]
  },
"Orders": {
    icon: <OrdersIcon />,
    label: "Orders",
    permissions: [
      { id: "orders", label: "Orders" },
      { id: "orders.view", label: "View Orders" },
      { id: "orders.edit", label: "Edit Orders" },
      { id: "orders.order_tracking_model", label: "Order Tracking Model" },
      { id: "orders.orderdetails", label: "Order Details" },
      { id: "orders.ordersview", label: "Orders View" }
    ]
  },
  "Users": {
    icon: <UsersIcon />,
    label: "Users",
    permissions: [
      { id: "users", label: "Users" },
      { id: "users.view", label: "View Users" },
      { id: "users.edit", label: "Edit Users" },
      { id: "users.OrderHistory", label: "Order History" },
      { id: "payment", label: "Payment" },
      { id: "orders", label: "Orders" },
      { id: "users.delete", label: "Delete Users" }
    ]
  },
  "Restaurants": {
    icon: <RestaurantIcon />,
    label: "Restaurants",
    permissions: [
      { id: "restaurants", label: "Restaurants" },
      {
        id: "restaurants.view",
        label: "View Restaurants",
        children: [
          { id: "restaurants.overview", label: "Overview" },
          { id: "restaurants.menu", label: "Menu" },
          { id: "restaurants.orders", label: "Orders" },
          { id: "restaurants.timings", label: "Timings" },
          { id: "restaurants.payments", label: "Payments" },
          { id: "restaurants.reviews", label: "Reviews" },
          { id: "restaurants.location", label: "Location" },
          { id: "restaurants.documents", label: "Documents" },
          { id: "restaurants.active_offers", label: "Active Offers" }
        ]
      },
      { id: "restaurants.edit", label: "Edit Restaurants" },
      { id: "restaurants.create", label: "Create Restaurants" },
      { id: "restaurants.delete", label: "Delete Restaurants" }
    ]
  },
  "Drivers": {
    icon: <UsersIcon />,
    label: "Drivers",
    permissions: [
      { id: "drivers", label: "Drivers" },
      {
        id: "drivers.view",
        label: "View Drivers",
        children: [
          { id: "drivers.overview", label: "Overview" },
          { id: "drivers.delivery_history", label: "Delivery History" },
          { id: "drivers.edit_driver", label: "Edit Driver" },
          { id: "drivers.verify_documents", label: "Verify Documents" },
          { id: "drivers.earnings", label: "Earnings" },
          { id: "drivers.wallet", label: "Wallet" },
          { id: "drivers.live_location", label: "Live Location" },
          { id: "drivers.assign_order", label: "Assign Order" }
        ]
      },
      { id: "drivers.create", label: "Create Drivers" },
      { id: "drivers.delete", label: "Delete Drivers" }
    ]
  },
  "Payments": {
    icon: <WalletIcon />,
    label: "Payments",
    permissions: [
      { id: "payments", label: "Payments" },
      { id: "payments.withdrawal", label: "Withdrawal" },
      { id: "payments.invoices", label: "Invoices" },
      { id: "payments.Cash Verification", label: "Cash Verification" },
      { id: "payments.Verified History", label: "Verified History" },
      { id: "payments.Locker to Bank", label: "Locker to Bank" },
      { id: "payments.Transit Tracker", label: "Transit Tracker" },
      { id: "payments.Bank History", label: "Bank History" },
    ]
  },
  "Dishes": {
    icon: <RestaurantIcon />,
    label: "Dishes",
    permissions: [
      { id: "Dishes", label: "Dishes" },
      { id: "dishes.menu", label: "Menu" }
    ]
  },
  "App Support": {
    icon: <SettingsIcon />,
    label: "App Support",
    permissions: [
      { id: "app_support", label: "App Support" },
      { id: "app_support.map", label: "Map" },
      { id: "app_support.support", label: "Support" },
      { id: "app_support.app_settings", label: "AppSettings" },
      { id: "app_support.tickets", label: "Tickets" },
      { id: "app_support.notifications", label: "Notifications" },
      { id: "app_support.send_notifications", label: "Send Notifications" },
      { id: "app_support.live_status", label: "Live Status" },
      { id: "app_support.banners", label: "Banners" },
      // ✅ ADDED: Restaurant Offer Banner permission
      { id: "app_support.restaurant_offer_banner", label: "Restaurant Offer Banner" },
      // ✅ ADDED: Restaurant Login Banner permission
      { id: "app_support.restaurant_login_banner", label: "Restaurant Login Banner" },
      { id: "website.locations", label: "Locations" },
      { id: "app_support.faq", label: "FAQ" }
    ]
  },
  "Config": {
    icon: <SettingsIcon />,
    label: "Config",
    permissions: [
      { id: "config", label: "Config" },
      { id: "config.delivery_fare", label: "Delivery Fare" },
      { id: "config.platform_fee", label: "Platform Fee" },
      { id: "config.application_pages", label: "Application Pages" },
    ]
  },
  "Website": {
    icon: <GlobeIcon />,
    label: "Website",
    permissions: [
      { id: "website.website", label: "Website" },
      { id: "website.web_banners", label: "Web Banners" },
      { id: "website.pages", label: "Pages" },
      { id: "website.privacy_policy", label: "Privacy Policy" },
      { id: "website.terms_conditions", label: "Terms & Conditions" },
      { id: "website.about_us", label: "About us" },
      { id: "website.cancellation_policy", label: "Cancellation policy" },
      { id: "website.refund_policy", label: "Refund policy" },
      { id: "website.services", label: "Services" },
      { id: "website.choose_us", label: "Choose Us" },
      { id: "website.press_release", label: "Press Release" },
      { id: "website.enquiries", label: "Enquiries" },
      { id: "website.footer_certificates", label: "Footer Certificates" },
      { id: "website.web_setting", label: "WebSetting" }
    ]
  },
  "Reports": {
    icon: <ReportsIcon />,
    label: "Reports",
    permissions: [
      { id: "reports", label: "Reports" },
      { id: "reports.view", label: "View Reports" }
    ]
  },
  "Dev Feedback": {
    icon: <StarIcon />,
    label: "Dev Feedback",
    permissions: [
      { id: "dev_feedback", label: "Dev Feedback" },
      { id: "dev_feedback.rating_review", label: "Rating&Review" },
      { id: "dev_feedback.dev_feedback", label: "Dev Feedback" }
    ]
  },
  "Settings": {
    icon: <SettingsIcon />,
    label: "Settings",
    permissions: [
      {
        id: "settings",
        label: "Settings",
        children: [
          { id: "settings.regions", label: "Regions" },
          { id: "settings.staff", label: "Staff" },
          { id: "settings.roles", label: "Roles" },
          { id: "settings.general", label: "General" }
        ]
      }
    ]
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// ROLE CARD COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const RoleCard = ({ role, theme, onEdit, onDelete, onClick }) => {
  let permissionsArray = [];
  if (Array.isArray(role.permissions)) {
    permissionsArray = role.permissions;
  } else if (typeof role.permissions === 'string') {
    try {
      permissionsArray = JSON.parse(role.permissions);
    } catch (e) {
      permissionsArray = [];
    }
  }
  const totalPermissions = permissionsArray.length;
  const isActive = role.status === 1;

  return (
    <div
      onClick={onClick}
      style={{
        background: theme.surface,
        border: `1px solid ${theme.border}`,
        borderRadius: "16px",
        padding: "18px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = `0 8px 25px ${theme.primary}20`;
        e.currentTarget.style.borderColor = theme.primary;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.borderColor = theme.border;
      }}
    >
      {/* Gradient Top Bar */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "3px",
        background: isActive
          ? `linear-gradient(90deg, ${theme.success}, ${theme.success}cc)`
          : `linear-gradient(90deg, ${theme.textMuted}, ${theme.textMuted}cc)`,
      }} />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
        <div style={{ flex: 1 }}>
          <h3 style={{ fontSize: "16px", fontWeight: 700, color: theme.textPrimary, margin: 0 }}>
            {role.role_name}
          </h3>
          <span style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            padding: "3px 10px",
            borderRadius: "20px",
            fontSize: "10px",
            fontWeight: 600,
            background: isActive ? `${theme.success}1a` : `${theme.textMuted}1a`,
            color: isActive ? theme.success : theme.textMuted,
            marginTop: "8px"
          }}>
            <span style={{
              width: "5px",
              height: "5px",
              borderRadius: "50%",
              background: isActive ? theme.success : theme.textMuted,
            }} />
            {isActive ? "Active" : "Inactive"}
          </span>
        </div>
        <div style={{ display: "flex", gap: "6px" }}>
          <button
            onClick={(e) => { e.stopPropagation(); onEdit(role); }}
            style={{
              padding: "6px 8px",
              borderRadius: "8px",
              border: `1px solid ${theme.warning}30`,
              background: `${theme.warning}15`,
              color: theme.warning,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.warning}25`)}
            onMouseLeave={(e) => (e.currentTarget.style.background = `${theme.warning}15`)}
            title="Edit Role"
          >
            <EditIcon />
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onDelete(role); }}
            style={{
              padding: "6px 8px",
              borderRadius: "8px",
              border: `1px solid ${theme.error || theme.danger}30`,
              background: `${theme.error || theme.danger}15`,
              color: theme.error || theme.danger,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = theme.error || theme.danger;
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = `${theme.error || theme.danger}15`;
              e.currentTarget.style.color = theme.error || theme.danger;
            }}
            title="Delete Role"
          >
            <TrashIcon />
          </button>
        </div>
      </div>

      {/* Permission Tags */}
      <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "14px" }}>
        {permissionsArray.slice(0, 3).map(permKey => (
          <span
            key={permKey}
            style={{
              fontSize: "9px",
              padding: "3px 8px",
              borderRadius: "6px",
              background: `${theme.primary}15`,
              color: theme.primary,
              fontWeight: 600,
              fontFamily: "monospace",
              border: `1px solid ${theme.primary}30`,
            }}
          >
            {permKey}
          </span>
        ))}
        {permissionsArray.length > 3 && (
          <span style={{
            fontSize: "9px",
            padding: "3px 8px",
            borderRadius: "6px",
            background: theme.surfaceLighter,
            color: theme.textMuted,
            fontWeight: 600,
            border: `1px solid ${theme.border}`,
          }}>
            +{permissionsArray.length - 3} more
          </span>
        )}
      </div>

      {/* Footer */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: "12px",
        borderTop: `1px solid ${theme.border}`
      }}>
        <span style={{
          fontSize: "11px",
          color: theme.textMuted,
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}>
          <ShieldIcon /> {totalPermissions} permission{totalPermissions !== 1 ? "s" : ""}
        </span>
        <span style={{
          fontSize: "11px",
          color: theme.primary,
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}>
          👥 {role.userCount || 0} staff
        </span>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// PERMISSION SECTION COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const PermissionSection = ({
  title,
  icon,
  permissions,
  selectedPermissions,
  onTogglePermission,
  theme,
  isExpanded,
  onToggleExpand,
  onSelectAll,
  onClearAll
}) => {
  const [nestedExpanded, setNestedExpanded] = useState({});

  const toggleNestedSection = (sectionId) => {
    setNestedExpanded(prev => ({ ...prev, [sectionId]: !prev[sectionId] }));
  };

  const calculateSelectedCount = (perms) => {
    let count = 0;
    perms.forEach(perm => {
      if (perm.children) {
        count += calculateSelectedCount(perm.children);
      } else if (selectedPermissions[perm.id]) {
        count++;
      }
    });
    return count;
  };

  const calculateTotalCount = (perms) => {
    let count = 0;
    perms.forEach(perm => {
      if (perm.children) {
        count += calculateTotalCount(perm.children);
      } else {
        count++;
      }
    });
    return count;
  };

  const selectedCount = calculateSelectedCount(permissions);
  const totalCount = calculateTotalCount(permissions);
  const isAllSelected = selectedCount === totalCount && totalCount > 0;

  const renderPermissions = (perms, level = 0) => {
    return perms.map(perm => {
      if (perm.children) {
        const isSectionExpanded = nestedExpanded[perm.id] || false;
        const childSelected = calculateSelectedCount(perm.children);
        const childTotal = calculateTotalCount(perm.children);
        const childAllSelected = childSelected === childTotal && childTotal > 0;
        const childSomeSelected = childSelected > 0 && !childAllSelected;

        return (
          <div key={perm.id} style={{ marginBottom: "6px", marginLeft: level > 0 ? "16px" : "0" }}>
            <div
              onClick={() => toggleNestedSection(perm.id)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "8px 12px",
                background: theme.surfaceLighter,
                borderRadius: "8px",
                cursor: "pointer",
                border: `1px solid ${theme.border}`,
                transition: "all 0.2s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = theme.primary;
                e.currentTarget.style.background = `${theme.primary}08`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = theme.border;
                e.currentTarget.style.background = theme.surfaceLighter;
              }}
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  const isChecked = !childAllSelected;
                  const toggleAll = (items) => {
                    items.forEach(item => {
                      if (item.children) {
                        toggleAll(item.children);
                      } else {
                        onTogglePermission(item.id, isChecked);
                      }
                    });
                  };
                  toggleAll(perm.children);
                }}
                style={{
                  width: "16px",
                  height: "16px",
                  borderRadius: "4px",
                  border: childAllSelected || childSomeSelected ? `2px solid ${theme.primary}` : `2px solid ${theme.border}`,
                  background: childAllSelected ? theme.primary : childSomeSelected ? `${theme.primary}40` : "transparent",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.15s ease",
                  flexShrink: 0,
                }}
              >
                {childAllSelected && <CheckIcon />}
                {childSomeSelected && !childAllSelected && (
                  <div style={{
                    width: "6px",
                    height: "2px",
                    background: "#fff",
                    borderRadius: "1px",
                  }} />
                )}
              </div>
              <span style={{
                fontWeight: 600,
                fontSize: "12px",
                color: theme.textPrimary,
                flex: 1
              }}>
                {perm.label}
              </span>
              <span style={{
                fontSize: "10px",
                color: theme.textMuted,
                fontWeight: 600,
                background: childSelected > 0 ? `${theme.primary}15` : theme.surface,
                padding: "2px 8px",
                borderRadius: "10px",
              }}>
                {childSelected}/{childTotal}
              </span>
              <span style={{ color: theme.textMuted, transition: "transform 0.2s" }}>
                {isSectionExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
              </span>
            </div>
            {isSectionExpanded && (
              <div style={{
                paddingLeft: "16px",
                marginTop: "6px",
                borderLeft: `2px solid ${theme.primary}40`,
                marginLeft: "8px",
              }}>
                {renderPermissions(perm.children, level + 1)}
              </div>
            )}
          </div>
        );
      }

      return (
        <label
          key={perm.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "6px 8px",
            cursor: "pointer",
            fontSize: "12px",
            color: theme.textPrimary,
            marginLeft: level > 0 ? "16px" : "0",
            borderBottom: `1px solid ${theme.border}`,
            transition: "background 0.15s",
            borderRadius: "4px",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.primary}08`)}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <div
            onClick={(e) => {
              e.preventDefault();
              onTogglePermission(perm.id);
            }}
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "4px",
              border: selectedPermissions[perm.id] ? `2px solid ${theme.primary}` : `2px solid ${theme.border}`,
              background: selectedPermissions[perm.id] ? theme.primary : "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.15s ease",
              flexShrink: 0,
            }}
          >
            {selectedPermissions[perm.id] && <CheckIcon />}
          </div>
          <span style={{ flex: 1 }}>{perm.label}</span>
          <span style={{
            fontSize: "9px",
            color: theme.textMuted,
            fontFamily: "monospace",
            background: theme.surfaceLighter,
            padding: "2px 6px",
            borderRadius: "4px",
            border: `1px solid ${theme.border}`,
          }}>
            {perm.id}
          </span>
        </label>
      );
    });
  };

  return (
    <div style={{ marginBottom: "12px" }}>
      <div
        onClick={onToggleExpand}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 16px",
          background: isExpanded ? `${theme.primary}10` : theme.surfaceLighter,
          borderRadius: "10px",
          cursor: "pointer",
          border: `1px solid ${isExpanded ? theme.primary : theme.border}`,
          transition: "all 0.2s",
        }}
        onMouseEnter={(e) => {
          if (!isExpanded) {
            e.currentTarget.style.borderColor = theme.primary;
            e.currentTarget.style.background = `${theme.primary}08`;
          }
        }}
        onMouseLeave={(e) => {
          if (!isExpanded) {
            e.currentTarget.style.borderColor = theme.border;
            e.currentTarget.style.background = theme.surfaceLighter;
          }
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <div style={{
            width: "32px",
            height: "32px",
            borderRadius: "8px",
            background: `${theme.primary}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: theme.primary,
          }}>
            {icon}
          </div>
          <span style={{ fontWeight: 700, fontSize: "13px", color: theme.textPrimary }}>
            {title}
          </span>
          <span style={{
            fontSize: "11px",
            color: selectedCount > 0 ? theme.primary : theme.textMuted,
            fontWeight: 600,
            background: selectedCount > 0 ? `${theme.primary}15` : theme.surface,
            padding: "2px 10px",
            borderRadius: "12px",
            border: `1px solid ${selectedCount > 0 ? `${theme.primary}30` : theme.border}`,
          }}>
            {selectedCount}/{totalCount}
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (isAllSelected) {
                onClearAll();
              } else {
                onSelectAll();
              }
            }}
            style={{
              fontSize: "10px",
              padding: "4px 12px",
              borderRadius: "6px",
              border: `1px solid ${isAllSelected ? (theme.error || theme.danger) : theme.primary}`,
              background: isAllSelected ? `${theme.error || theme.danger}15` : `${theme.primary}15`,
              color: isAllSelected ? (theme.error || theme.danger) : theme.primary,
              cursor: "pointer",
              fontWeight: 700,
              transition: "all 0.2s",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = isAllSelected ? (theme.error || theme.danger) : theme.primary;
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = isAllSelected ? `${theme.error || theme.danger}15` : `${theme.primary}15`;
              e.currentTarget.style.color = isAllSelected ? (theme.error || theme.danger) : theme.primary;
            }}
          >
            {isAllSelected ? "Clear All" : "Select All"}
          </button>
          <span style={{ color: theme.textMuted }}>
            {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
          </span>
        </div>
      </div>

      {isExpanded && (
        <div style={{
          padding: "14px",
          background: theme.surface,
          borderRadius: "10px",
          marginTop: "6px",
          border: `1px solid ${theme.border}`,
          animation: "slideDown 0.2s ease-out",
        }}>
          {renderPermissions(permissions)}
        </div>
      )}
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN ROLES & PERMISSIONS COMPONENT (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────
const RolesPermissions = () => {
  const { theme } = useContext(ThemeContext); // ← Theme Context

  const [roles, setRoles] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [loadingRoles, setLoadingRoles] = useState(true);
  const [loadingAdmins, setLoadingAdmins] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedSections, setExpandedSections] = useState({});
  const [loading, setLoading] = useState(false);
  const [roleFormData, setRoleFormData] = useState({
    role_name: "",
    status: 1,
    admin_id: "",
    permissions: {}
  });

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    setLoadingRoles(true);
    try {
      console.log("📤 Fetching roles from API...");
      const response = await getData("RolesPermissions/fetch_roles");
      console.log("📥 Fetch Roles Response:", response);

      if (response && response.status === true) {
        const rolesData = response.data || [];
        const parsedRoles = rolesData.map(role => {
          if (typeof role.permissions === 'string') {
            try {
              role.permissions = JSON.parse(role.permissions);
            } catch (e) {
              role.permissions = role.permissions.split(',').map(p => p.trim()).filter(p => p);
            }
          }
          if (!role.permissions || !Array.isArray(role.permissions)) {
            role.permissions = [];
          }
          return role;
        });
        setRoles(parsedRoles);
      } else {
        console.warn("Failed to fetch roles:", response?.message);
        setRoles(getDefaultRoles());
      }
    } catch (error) {
      console.error("❌ Error fetching roles:", error);
      setRoles(getDefaultRoles());
    } finally {
      setLoadingRoles(false);
    }
  };

  const fetchAdmins = async () => {
    setLoadingAdmins(true);
    try {
      const response = await getData("RolesPermissions/fetch_admins");
      if (response && response.status === true) {
        setAdmins(response.data || []);
      } else {
        setAdmins([]);
      }
    } catch (error) {
      console.error("❌ Error fetching admins:", error);
      setAdmins([]);
    } finally {
      setLoadingAdmins(false);
    }
  };

  useEffect(() => {
    if (showCreateModal || showEditModal) {
      fetchAdmins();
    }
  }, [showCreateModal, showEditModal]);

  const getDefaultRoles = () => [
    {
      id: 1, role_name: "Super Admin", status: 1, hide: 0, userCount: 1,
      permissions: ["dashboard", "orders.view", "orders.edit", "orders.create", "orders.delete", "users.view", "users.edit", "users.create", "users.delete", "restaurants.view", "restaurants.edit", "restaurants.create", "restaurants.delete", "reports.view", "settings.view", "settings.edit", "roles.view", "roles.edit", "roles.create", "roles.delete"]
    },
    {
      id: 2, role_name: "Manager", status: 1, hide: 0, userCount: 3,
      permissions: ["dashboard", "orders.view", "orders.edit", "users.view", "restaurants.view", "restaurants.edit", "reports.view", "settings.view"]
    },
    {
      id: 3, role_name: "Viewer", status: 1, hide: 0, userCount: 2,
      permissions: ["dashboard", "orders.view", "users.view", "restaurants.view", "reports.view"]
    }
  ];

  const toggleSection = (section) => {
    setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
  };

  const togglePermission = (permId, checked) => {
    setRoleFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [permId]: checked !== undefined ? checked : !prev.permissions[permId]
      }
    }));
  };

  const getAllPermissionIds = (perms) => {
    let ids = [];
    perms.forEach(perm => {
      if (perm.children) {
        ids = [...ids, ...getAllPermissionIds(perm.children)];
      } else {
        ids.push(perm.id);
      }
    });
    return ids;
  };

  const getPermissionsArray = (permissionsObj) => {
    return Object.keys(permissionsObj).filter(key => permissionsObj[key] === true);
  };

  const selectAllCategory = (category) => {
    const categoryPermissions = PERMISSIONS_DATA[category].permissions;
    const newPermissions = { ...roleFormData.permissions };
    getAllPermissionIds(categoryPermissions).forEach(id => { newPermissions[id] = true; });
    setRoleFormData(prev => ({ ...prev, permissions: newPermissions }));
  };

  const clearCategory = (category) => {
    const categoryPermissions = PERMISSIONS_DATA[category].permissions;
    const newPermissions = { ...roleFormData.permissions };
    getAllPermissionIds(categoryPermissions).forEach(id => { newPermissions[id] = false; });
    setRoleFormData(prev => ({ ...prev, permissions: newPermissions }));
  };

  const selectAll = () => {
    const newPermissions = {};
    Object.keys(PERMISSIONS_DATA).forEach(category => {
      getAllPermissionIds(PERMISSIONS_DATA[category].permissions).forEach(id => {
        newPermissions[id] = true;
      });
    });
    setRoleFormData(prev => ({ ...prev, permissions: newPermissions }));
  };

  const clearAll = () => {
    setRoleFormData(prev => ({ ...prev, permissions: {} }));
  };

  const handleCreateRole = async () => {
    if (!roleFormData.role_name.trim()) {
      alert("Please enter role name");
      return;
    }
    if (!roleFormData.admin_id) {
      alert("Please select an admin");
      return;
    }
    const permissionsArray = getPermissionsArray(roleFormData.permissions);
    const payload = {
      role_name: roleFormData.role_name,
      status: roleFormData.status,
      Admin_id: parseInt(roleFormData.admin_id),
      permissions: permissionsArray
    };

    setLoading(true);
    try {
      const response = await postData("RolesPermissions/add_role", payload);
      if (response && response.status === true) {
        alert(response.message || "Role created successfully!");
        setShowCreateModal(false);
        setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
        await fetchRoles();
      } else {
        alert(response?.message || "Failed to create role");
      }
    } catch (error) {
      alert("Error creating role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEditRole = async () => {
    if (!roleFormData.role_name.trim()) {
      alert("Please enter role name");
      return;
    }
    if (!roleFormData.admin_id) {
      alert("Please select an admin");
      return;
    }
    const permissionsArray = getPermissionsArray(roleFormData.permissions);
    const payload = {
      id: selectedRole.id,
      role_name: roleFormData.role_name,
      status: roleFormData.status,
      Admin_id: parseInt(roleFormData.admin_id),
      permissions: permissionsArray
    };

    setLoading(true);
    try {
      const response = await postData("RolesPermissions/update_role", payload);
      if (response && response.status === true) {
        alert(response.message || "Role updated successfully!");
        setShowEditModal(false);
        setSelectedRole(null);
        setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
        await fetchRoles();
      } else {
        alert(response?.message || "Failed to update role");
      }
    } catch (error) {
      alert("Error updating role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteRole = async (role) => {
    if (!window.confirm(`Are you sure you want to delete role "${role.role_name}"?`)) return;
    setLoading(true);
    try {
      const response = await postData("RolesPermissions/delete_role", { id: role.id });
      if (response && response.status === true) {
        alert(response.message || "Role deleted successfully!");
        await fetchRoles();
      } else {
        alert(response?.message || "Failed to delete role");
      }
    } catch (error) {
      alert("Error deleting role: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = (role) => {
    setSelectedRole(role);
    const permissionsObj = {};
    const populatePermissions = (perms) => {
      perms.forEach(perm => {
        if (perm.children) populatePermissions(perm.children);
        else permissionsObj[perm.id] = (role.permissions || []).includes(perm.id);
      });
    };
    Object.keys(PERMISSIONS_DATA).forEach(category => {
      populatePermissions(PERMISSIONS_DATA[category].permissions);
    });
    setRoleFormData({
      role_name: role.role_name,
      status: role.status,
      admin_id: role.Admin_id || role.admin_id || "",
      permissions: permissionsObj
    });
    setShowEditModal(true);
  };

  const filteredRoles = roles.filter(role =>
    role.role_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const calculateTotalPermissions = () => {
    let count = 0;
    Object.keys(PERMISSIONS_DATA).forEach(category => {
      count += getAllPermissionIds(PERMISSIONS_DATA[category].permissions).length;
    });
    return count;
  };

  const totalPermissions = calculateTotalPermissions();
  const selectedPermissionsCount = Object.values(roleFormData.permissions).filter(v => v === true).length;

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    background: theme.surfaceLighter,
    border: `1px solid ${theme.border}`,
    borderRadius: "10px",
    color: theme.textPrimary,
    fontSize: "13px",
    outline: "none",
    transition: "all 0.2s",
    boxSizing: "border-box",
    fontFamily: "inherit",
  };

  const labelStyle = {
    display: "block",
    fontSize: "11px",
    fontWeight: 700,
    color: theme.textSecondary,
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  };

  // ─── Loading State ─────────────────────────────────────────────
  if (loadingRoles) {
    return (
      <div style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: theme.background,
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: "56px",
            height: "56px",
            border: `3px solid ${theme.border}`,
            borderTopColor: theme.primary,
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto 20px",
          }} />
          <p style={{ color: theme.textMuted, fontSize: "14px", margin: 0 }}>
            Loading roles...
          </p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: theme.background,
      padding: "24px",
      fontFamily: "'DM Sans', sans-serif",
      transition: "background 0.3s ease",
    }}>
      <style>{`
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes slideDown { from { opacity: 0; max-height: 0; } to { opacity: 1; max-height: 2000px; } }
      `}</style>

      {/* Header */}
      <div style={{ marginBottom: "24px", display: "flex", alignItems: "center", gap: "14px" }}>
        <div style={{
          width: "52px",
          height: "52px",
          borderRadius: "14px",
          background: `linear-gradient(135deg, ${theme.primary}, ${theme.primary}cc)`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          boxShadow: `0 4px 12px ${theme.primary}40`,
        }}>
          <ShieldIcon />
        </div>
        <div>
          <h1 style={{
            fontSize: "24px",
            fontWeight: 700,
            color: theme.textPrimary,
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}>
            Roles & Permissions
            <span style={{
              fontSize: "12px",
              fontWeight: 600,
              color: theme.primary,
              background: `${theme.primary}15`,
              padding: "3px 10px",
              borderRadius: "20px",
            }}>
              {roles.length} roles
            </span>
          </h1>
          <p style={{ fontSize: "13px", color: theme.textMuted, margin: "4px 0 0" }}>
            Manage roles and their access permissions
          </p>
        </div>
      </div>

      {/* Actions Bar */}
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "12px"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: "10px",
          padding: "6px 12px",
          flex: 1,
          maxWidth: "400px",
          minWidth: "250px",
          transition: "all 0.2s",
        }}>
          <span style={{ color: theme.textMuted, display: "flex" }}><SearchIcon /></span>
          <input
            type="text"
            placeholder="Search roles..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              flex: 1,
              background: "transparent",
              border: "none",
              outline: "none",
              color: theme.textPrimary,
              fontSize: "13px",
              fontFamily: "inherit",
            }}
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm("")}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                color: theme.textMuted,
                padding: "2px",
                display: "flex",
              }}
            >
              <XIcon />
            </button>
          )}
        </div>

        <button
          onClick={() => {
            setShowCreateModal(true);
            setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px 20px",
            background: theme.primary,
            border: "none",
            borderRadius: "10px",
            color: "#fff",
            fontWeight: 600,
            fontSize: "13px",
            cursor: "pointer",
            boxShadow: `0 4px 12px ${theme.primary}40`,
            transition: "all 0.2s",
            opacity: loading ? 0.6 : 1,
          }}
          disabled={loading}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`;
          }}
        >
          <PlusIcon /> {loading ? "Processing..." : "Create New Role"}
        </button>
      </div>

      {/* Roles Grid */}
      {filteredRoles.length === 0 ? (
        <div style={{
          background: theme.surface,
          border: `1px solid ${theme.border}`,
          borderRadius: "16px",
          padding: "60px",
          textAlign: "center",
          boxShadow: `0 4px 12px ${theme.primary}08`,
        }}>
          <div style={{
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: `${theme.primary}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            color: theme.primary,
          }}>
            <RolesIcon />
          </div>
          <h3 style={{ color: theme.textPrimary, marginBottom: "8px", fontSize: "16px", fontWeight: 600 }}>
            {searchTerm ? "No Matching Roles" : "No Roles Found"}
          </h3>
          <p style={{ color: theme.textMuted, fontSize: "13px", margin: 0 }}>
            {searchTerm ? "Try a different search term" : 'Click "Create New Role" to add your first role'}
          </p>
        </div>
      ) : (
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
          gap: "16px"
        }}>
          {filteredRoles.map(role => (
            <RoleCard
              key={role.id}
              role={role}
              theme={theme}
              onEdit={openEditModal}
              onDelete={deleteRole}
              onClick={() => openEditModal(role)}
            />
          ))}
        </div>
      )}

      {/* Create/Edit Role Modal */}
      {(showCreateModal || showEditModal) && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.7)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
            animation: "fadeIn 0.2s ease-out",
          }}
          onClick={() => {
            setShowCreateModal(false);
            setShowEditModal(false);
            setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
          }}
        >
          <div
            style={{
              background: theme.surface,
              borderRadius: "20px",
              width: "100%",
              maxWidth: "900px",
              maxHeight: "90vh",
              overflow: "auto",
              border: `1px solid ${theme.border}`,
              boxShadow: `0 25px 60px ${theme.primary}30`,
              animation: "slideUp 0.3s ease-out",
              display: "flex",
              flexDirection: "column",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 24px",
              borderBottom: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
              position: "sticky",
              top: 0,
              zIndex: 1,
              flexShrink: 0,
            }}>
              <h2 style={{
                fontSize: "18px",
                fontWeight: 700,
                color: theme.textPrimary,
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}>
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "8px",
                  background: `${theme.primary}15`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: theme.primary,
                }}>
                  {showCreateModal ? <PlusIcon /> : <EditIcon />}
                </div>
                {showCreateModal ? "Create New Role" : `Edit Role: ${selectedRole?.role_name}`}
              </h2>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setShowEditModal(false);
                  setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: theme.textMuted,
                  padding: "6px",
                  display: "flex",
                  borderRadius: "8px",
                  transition: "all 0.2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                  e.currentTarget.style.color = theme.error || theme.danger;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "none";
                  e.currentTarget.style.color = theme.textMuted;
                }}
              >
                <CloseIcon />
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: "24px", flex: 1, overflowY: "auto" }}>
              {/* Role Name Input */}
              <div style={{ marginBottom: "20px" }}>
                <label style={labelStyle}>
                  Role Name <span style={{ color: theme.error || theme.danger }}>*</span>
                </label>
                <input
                  type="text"
                  value={roleFormData.role_name}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, role_name: e.target.value }))}
                  placeholder="e.g., Manager, Viewer"
                  style={inputStyle}
                  disabled={loading}
                  onFocus={(e) => {
                    e.currentTarget.style.borderColor = theme.primary;
                    e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.primary}15`;
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.borderColor = theme.border;
                    e.currentTarget.style.boxShadow = "none";
                  }}
                />
              </div>

              {/* Admin Dropdown */}
              <div style={{ marginBottom: "20px" }}>
                <label style={labelStyle}>
                  Assign Admin <span style={{ color: theme.error || theme.danger }}>*</span>
                </label>
                <select
                  value={roleFormData.admin_id}
                  onChange={(e) => setRoleFormData(prev => ({ ...prev, admin_id: e.target.value }))}
                  style={{ ...inputStyle, cursor: loadingAdmins ? "not-allowed" : "pointer" }}
                  disabled={loading || loadingAdmins}
                  onFocus={(e) => (e.currentTarget.style.borderColor = theme.primary)}
                  onBlur={(e) => (e.currentTarget.style.borderColor = theme.border)}
                >
                  <option value="">{loadingAdmins ? "Loading admins..." : "Select an admin"}</option>
                  {admins.map(admin => (
                    <option key={admin.id} value={admin.id}>{admin.name}</option>
                  ))}
                </select>
                {loadingAdmins && (
                  <div style={{ fontSize: "11px", color: theme.warning, marginTop: "4px", display: "flex", alignItems: "center", gap: "4px" }}>
                    ⏳ Loading admins...
                  </div>
                )}
                {!loadingAdmins && admins.length === 0 && (
                  <div style={{ fontSize: "11px", color: theme.error || theme.danger, marginTop: "4px" }}>
                    ⚠️ No admins found. Please add an admin first.
                  </div>
                )}
              </div>

              {/* Status Select */}
              <div style={{ marginBottom: "20px" }}>
                <label style={labelStyle}>Status</label>
                <div style={{ display: "flex", gap: "10px", marginTop: "8px" }}>
                  <label style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: theme.textPrimary,
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${roleFormData.status === 1 ? theme.success : theme.border}`,
                    background: roleFormData.status === 1 ? `${theme.success}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}>
                    <input
                      type="radio"
                      value={1}
                      checked={roleFormData.status === 1}
                      onChange={(e) => setRoleFormData(prev => ({ ...prev, status: parseInt(e.target.value) }))}
                      style={{ accentColor: theme.success }}
                    /> 🟢 Active
                  </label>
                  <label style={{
                    flex: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    cursor: "pointer",
                    fontSize: "13px",
                    color: theme.textPrimary,
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${roleFormData.status === 0 ? theme.textMuted : theme.border}`,
                    background: roleFormData.status === 0 ? `${theme.textMuted}15` : "transparent",
                    transition: "all 0.2s",
                    fontWeight: 500,
                  }}>
                    <input
                      type="radio"
                      value={0}
                      checked={roleFormData.status === 0}
                      onChange={(e) => setRoleFormData(prev => ({ ...prev, status: parseInt(e.target.value) }))}
                      style={{ accentColor: theme.textMuted }}
                    /> ⚫ Inactive
                  </label>
                </div>
              </div>

              {/* Permissions Section */}
              <div>
                <div style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "14px",
                  padding: "12px 16px",
                  background: theme.surfaceLighter,
                  borderRadius: "10px",
                  border: `1px solid ${theme.border}`,
                }}>
                  <h3 style={{
                    fontSize: "14px",
                    fontWeight: 700,
                    color: theme.textPrimary,
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}>
                    <ShieldIcon /> Permissions
                    <span style={{
                      fontSize: "12px",
                      fontWeight: 700,
                      color: selectedPermissionsCount > 0 ? theme.primary : theme.textMuted,
                      background: selectedPermissionsCount > 0 ? `${theme.primary}15` : theme.surface,
                      padding: "3px 10px",
                      borderRadius: "12px",
                      border: `1px solid ${selectedPermissionsCount > 0 ? `${theme.primary}30` : theme.border}`,
                    }}>
                      {selectedPermissionsCount}/{totalPermissions}
                    </span>
                  </h3>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      onClick={selectAll}
                      style={{
                        fontSize: "11px",
                        color: "#fff",
                        background: theme.primary,
                        border: "none",
                        borderRadius: "6px",
                        padding: "6px 12px",
                        cursor: "pointer",
                        fontWeight: 600,
                        transition: "all 0.2s",
                      }}
                      disabled={loading}
                      onMouseEnter={(e) => (e.currentTarget.style.background = `${theme.primary}cc`)}
                      onMouseLeave={(e) => (e.currentTarget.style.background = theme.primary)}
                    >
                      Select All
                    </button>
                    <button
                      onClick={clearAll}
                      style={{
                        fontSize: "11px",
                        color: theme.error || theme.danger,
                        background: `${theme.error || theme.danger}15`,
                        border: `1px solid ${theme.error || theme.danger}30`,
                        borderRadius: "6px",
                        padding: "6px 12px",
                        cursor: "pointer",
                        fontWeight: 600,
                        transition: "all 0.2s",
                      }}
                      disabled={loading}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = theme.error || theme.danger;
                        e.currentTarget.style.color = "#fff";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = `${theme.error || theme.danger}15`;
                        e.currentTarget.style.color = theme.error || theme.danger;
                      }}
                    >
                      Clear All
                    </button>
                  </div>
                </div>

                {Object.entries(PERMISSIONS_DATA).map(([category, data]) => (
                  <PermissionSection
                    key={category}
                    title={category}
                    icon={data.icon}
                    permissions={data.permissions}
                    selectedPermissions={roleFormData.permissions}
                    onTogglePermission={togglePermission}
                    theme={theme}
                    isExpanded={expandedSections[category] || false}
                    onToggleExpand={() => toggleSection(category)}
                    onSelectAll={() => selectAllCategory(category)}
                    onClearAll={() => clearCategory(category)}
                  />
                ))}
              </div>
            </div>

            {/* Modal Footer */}
            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "12px",
              padding: "16px 24px",
              borderTop: `1px solid ${theme.border}`,
              background: theme.surfaceLighter,
              flexShrink: 0,
            }}>
              <button
                onClick={() => {
                  setShowCreateModal(false);
                  setShowEditModal(false);
                  setRoleFormData({ role_name: "", status: 1, admin_id: "", permissions: {} });
                }}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: `1px solid ${theme.border}`,
                  background: "transparent",
                  color: theme.textPrimary,
                  cursor: "pointer",
                  fontSize: "13px",
                  fontWeight: 500,
                  transition: "all 0.2s",
                }}
                disabled={loading}
                onMouseEnter={(e) => (e.currentTarget.style.background = theme.surfaceHover || theme.surface)}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                Cancel
              </button>
              <button
                onClick={showCreateModal ? handleCreateRole : handleEditRole}
                style={{
                  padding: "10px 24px",
                  borderRadius: "10px",
                  border: "none",
                  background: loading ? theme.textMuted : theme.primary,
                  color: "#fff",
                  cursor: loading ? "not-allowed" : "pointer",
                  fontSize: "13px",
                  fontWeight: 600,
                  boxShadow: loading ? "none" : `0 4px 12px ${theme.primary}40`,
                  transition: "all 0.2s",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
                disabled={loading}
                onMouseEnter={(e) => {
                  if (!loading) {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow = `0 6px 16px ${theme.primary}60`;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = loading ? "none" : `0 4px 12px ${theme.primary}40`;
                }}
              >
                {loading ? "⏳ Saving..." : (showCreateModal ? "Create Role" : "Save Changes")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RolesPermissions;
